import React, { ReactNode } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import styles from './ButtonAlt.module.scss';
import Icon from '../Icon/Icon';

type ButtonAltProps = {
  children?: string | ReactNode;
  icon?: IconProp;
  theme?: 'gray';
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};

function ButtonAlt({
  children,
  icon,
  theme,
  className,
  onClick,
  disabled,
}: ButtonAltProps) {
  return (
    <button
      className={[
        styles.root,
        theme ? styles[theme] : '',
        disabled ? styles.disabled : '',
        className ? className : '',
      ].join(' ')}
      onClick={!!onClick ? onClick : undefined}
      disabled={disabled}
    >
      {icon && (
        <Icon
          icon={icon}
          className={[styles.icon, children ? styles.mr : ''].join(' ')}
        />
      )}
      {children && <span>{children}</span>}
    </button>
  );
}

export default ButtonAlt;
